<template>
  <div class="project-setting-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2 class="page-title">项目设置</h2>
    </div>

    <!-- 设置卡片 -->
    <el-card class="setting-card" shadow="hover">
      <div slot="header" class="card-header">
        <i class="el-icon-setting"></i>
        <span>基础设置</span>
      </div>

      <el-form ref="form" :model="form" :rules="rules" class="setting-form">
        <!-- 出租屋入户率设置 -->
        <div class="setting-item">
          <div class="setting-info">
            <div class="setting-title">
              <i class="el-icon-house"></i>
              出租屋入户率
            </div>
            <div class="setting-description">
              设置出租屋检测的入户率阈值，用于计算检测完成度
            </div>
          </div>
          <div class="setting-control">
            <div class="setting-form-wrapper">
              <div class="form-row">
                <label class="form-label">入户率</label>
                <el-input-number 
                  v-model="form.rhl" 
                  :min="1" 
                  :max="100" 
                  :precision="2"
                  controls-position="right"
                  size="medium"
                  class="form-input rate-input">
                  <template slot="append">%</template>
                </el-input-number>
              </div>
              <div class="form-row">
                <label class="form-label"></label>
                <el-button 
                  type="primary" 
                  @click="submitForm()" 
                  :loading="loading"
                  icon="el-icon-check"
                  size="medium"
                  class="form-button">
                  更新入户率
                </el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 修改报告编号设置 -->
        <div class="setting-item">
          <div class="setting-info">
            <div class="setting-title">
              <i class="el-icon-document"></i>
              修改报告编号
            </div>
            <div class="setting-description">
              修改指定场所的报告编号
            </div>
          </div>
          <div class="setting-control">
            <div class="setting-form-wrapper">
              <div class="form-row">
                <label class="form-label">场所ID</label>
                <el-input 
                  v-model="reportForm.site_id" 
                  placeholder="请输入场所ID"
                  size="medium"
                  class="form-input">
                </el-input>
              </div>
              <div class="form-row">
                <label class="form-label">新报告编号</label>
                <el-input 
                  v-model="reportForm.report_code" 
                  placeholder="请输入新报告编号"
                  size="medium"
                  class="form-input">
                </el-input>
              </div>
              <div class="form-row">
                <label class="form-label"></label>
                <el-button 
                  type="primary" 
                  @click="submitReportChange()" 
                  :loading="reportLoading"
                  icon="el-icon-edit"
                  size="medium"
                  class="form-button">
                  修改报告编号
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      reportLoading: false,
      form: {
        rhl: 80
      },
      reportForm: {
        site_id: '',
        report_code: ''
      },
      rules: {
        rhl: [
          { required: true, message: '请输入出租屋入户率', trigger: 'blur' },
          { type: 'number', min: 1, max: 100, message: '入户率必须在1-100之间', trigger: 'blur' }
        ]
      },
      reportRules: {
        site_id: [
          { required: true, message: '请输入场所ID', trigger: 'blur' }
        ],
        report_code: [
          { required: true, message: '请输入新报告编号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async getList() {
      try {
        let params = {
          project_id: this.$route.params.project_id
        }
        let res = await this.$Api.get("project_setting", { params: params });
        if (res) {
          res.forEach(setting => {
            this.form[setting.setting_name] = parseFloat(setting.setting_value) || 80;
          });
        }
      } catch (e) {
        this.$notify({ 
          title: '获取数据出错', 
          message: e.message,
          type: 'error'
        })
      }
    },

    async submitForm() {
      try {
        // 表单验证
        await this.$refs.form.validate();
        
        this.loading = true;
        let params = {
          project_id: this.$route.params.project_id,
          rhl: this.form.rhl
        }
        
        await this.$Api.post("project_setting", params);
        
        this.$notify({ 
          title: '保存成功', 
          message: '项目设置已更新', 
          type: 'success',
          duration: 3000
        });
        
      } catch (e) {
        if (e.errormsg) {
          this.$notify({ 
            title: '保存失败', 
            message: e.errormsg,
            type: 'error'
          });
        }
      } finally {
        this.loading = false;
      }
    },

    async submitReportChange() {
      try {
        // 简单验证
        if (!this.reportForm.site_id) {
          this.$notify({ 
            title: '验证失败', 
            message: '请输入场所ID',
            type: 'warning'
          });
          return;
        }
        if (!this.reportForm.report_code) {
          this.$notify({ 
            title: '验证失败', 
            message: '请输入新报告编号',
            type: 'warning'
          });
          return;
        }
        
        this.reportLoading = true;
        let params = {
          project_id: this.$route.params.project_id,
          site_id: this.reportForm.site_id,
          report_code: this.reportForm.report_code
        }
        
        await this.$Api.post("change_report_code", params);
        
        this.$notify({ 
          title: '修改成功', 
          message: '报告编号已更新', 
          type: 'success',
          duration: 3000
        });
        
        // 清空表单
        this.reportForm.site_id = '';
        this.reportForm.report_code = '';
        
      } catch (e) {
        if (e.errormsg) {
          this.$notify({ 
            title: '修改失败', 
            message: e.errormsg,
            type: 'error'
          });
        }
      } finally {
        this.reportLoading = false;
      }
    },

    resetForm() {
      this.$refs.form.resetFields();
      // 重新获取原始数据
      this.getList();
    }
  },

  created() {
    this.getList()
  }
}
</script>

<style scoped>
.project-setting-container {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  margin-bottom: 24px;
  text-align: left;
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
}

.page-title::before {
  content: '';
  width: 4px;
  height: 28px;
  background: linear-gradient(135deg, #409eff, #66b1ff);
  margin-right: 12px;
  border-radius: 2px;
}

.page-description {
  font-size: 14px;
  color: #909399;
  margin: 0;
  margin-left: 16px;
}

/* 设置卡片 */
.setting-card {
  margin-bottom: 24px;
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.card-header i {
  margin-right: 8px;
  font-size: 18px;
  color: #409eff;
}

/* 设置表单 */
.setting-form {
  padding: 0;
}

.setting-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 0;
  border-bottom: 1px solid #f0f2f5;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-info {
  flex: 1;
  margin-right: 24px;
}

.setting-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.setting-title i {
  margin-right: 8px;
  color: #409eff;
  font-size: 16px;
}

.setting-description {
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.setting-control {
  min-width: 200px;
  display: flex;
  align-items: flex-start;
}

.setting-control .el-form-item {
  margin-bottom: 0;
}

/* 输入框样式 */
.rate-input {
  width: 240px;
}

.rate-input :deep(.el-input-group__append) {
  background: #409eff;
  color: white;
  border-color: #409eff;
}

/* 统一表单布局 */
.setting-form-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.form-label {
  width: 100px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  text-align: left;
  flex-shrink: 0;
}

.form-input {
  width: 240px;
  height: 40px;
}

.form-input :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
}

.form-button {
  height: 40px;
  min-width: 100px;
  background: #409eff;
  border-color: #409eff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-button:hover,
.form-button:focus {
  background: #66b1ff;
  border-color: #66b1ff;
  color: white;
}

/* 统一输入框和按钮尺寸 */
.el-input,
.el-input-number,
.el-button {
  height: 40px;
}

.el-input :deep(.el-input__inner),
.el-input-number :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
}

/* 报告编号修改相关样式 */
.report-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 300px;
  align-items: flex-start;
}

/* 入户率设置样式 */
.rate-setting-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}

.rate-setting-form .el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.rate-save-btn {
  min-width: 100px;
  margin-top: 4px;
  height: 40px;
  margin-left: 0;
}

.form-item-inline {
  margin-bottom: 0;
  width: 100%;
}

.form-item-inline .el-form-item__label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  width: 100px;
  text-align: left;
  line-height: 40px;
  padding-right: 12px;
}

.form-item-inline .el-form-item__content {
  margin-left: 100px !important;
  width: calc(100% - 100px);
}

.place-input,
.report-input {
  width: 240px;
}

/* 统一按钮样式 */
.rate-save-btn,
.submit-btn {
  background: #409eff;
  border-color: #409eff;
  color: white;
  min-width: 100px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rate-save-btn:hover,
.rate-save-btn:focus,
.submit-btn:hover,
.submit-btn:focus {
  background: #66b1ff;
  border-color: #66b1ff;
  color: white;
}

/* 操作按钮 */
.submit-btn {
  align-self: flex-start;
  margin-top: 8px;
  height: 40px;
  margin-left: 100px; /* 与输入框左边缘对齐 */
}

/* 帮助卡片 */
.help-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.help-content {
  padding: 0;
}

.help-content .el-alert {
  border: none;
  background: #f8fbff;
  border-radius: 8px;
}

.help-content .el-alert p {
  margin: 4px 0;
  color: #606266;
  font-size: 13px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .project-setting-container {
    padding: 16px;
  }
  
  .setting-item {
    flex-direction: column;
    align-items: stretch;
  }
  
  .setting-info {
    margin-right: 0;
    margin-bottom: 16px;
  }
  
  .setting-control {
    min-width: auto;
  }
  
  .rate-input {
    width: 100%;
  }
  
  .rate-input,
  .place-input,
  .report-input {
    width: 100%;
  }
  
  .report-form {
    min-width: auto;
  }
  
  .place-input,
  .report-input {
    width: 100%;
  }
  
  .form-item-inline .el-form-item__label {
    width: 100px;
  }
  
  .form-item-inline .el-form-item__content {
    margin-left: 0 !important;
    width: 100%;
  }
  
  .submit-btn {
    margin-left: 0;
  }
}

/* 卡片hover效果 */
.setting-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

/* 表单验证样式优化 */
:deep(.el-form-item__error) {
  position: static;
  margin-top: 4px;
  color: #f56c6c;
  font-size: 12px;
}
</style>